function passwordGenerator() {
    return {
        length: 16,
        upper: true,
        lower: true,
        numbers: true,
        symbols: true,
        excludeAmbiguous: false,
        
        password: '',
        strengthPercent: 0,
        strengthColor: '#ef4444',
        strengthText: 'WEAK',
        
        copied: false,
        history: [],

        init() {
            this.generate();
        },

        copyPassword() {
            if (!this.password || this.password === 'Select Options') return;
            navigator.clipboard.writeText(this.password).then(() => {
                this.copied = true;
                setTimeout(() => this.copied = false, 2000);
            });
        },

        copyHistory(text) {
            navigator.clipboard.writeText(text);
        },
        
        clearHistory() {
            this.history = [];
        },

        calculateStrength(pwd) {
            let score = 0;
            if (!pwd) return { percent: 0, color: '#ef4444', text: 'WEAK' };

            // Length points
            score += pwd.length * 4;
            
            // Diversity points
            if (/[A-Z]/.test(pwd)) score += 10;
            if (/[a-z]/.test(pwd)) score += 10;
            if (/[0-9]/.test(pwd)) score += 10;
            if (/[^A-Za-z0-9]/.test(pwd)) score += 15;
            
            // Cap at 100
            if (score > 100) score = 100;

            let color = '#ef4444'; // Red
            let text = 'WEAK';
            
            if (score > 80) {
                color = '#22c55e'; // Green
                text = 'VERY STRONG';
            } else if (score > 60) {
                color = '#3b82f6'; // Blue
                text = 'STRONG';
            } else if (score > 40) {
                color = '#eab308'; // Yellow
                text = 'MODERATE';
            }

            return { percent: score, color, text };
        },

        generate() {
            let charset = '';
            const ambiguous = 'Il1Oo0';

            if (this.upper) charset += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            if (this.lower) charset += 'abcdefghijklmnopqrstuvwxyz';
            if (this.numbers) charset += '0123456789';
            if (this.symbols) charset += '!@#$%^&*()_+-=[]{}|;:,.<>?~';

            if (this.excludeAmbiguous) {
                charset = charset.split('').filter(c => !ambiguous.includes(c)).join('');
            }

            if (!charset) {
                this.password = 'Select Options';
                this.strengthPercent = 0;
                return;
            }

            let pwd = '';
            const array = new Uint32Array(this.length);
            window.crypto.getRandomValues(array);
            
            for (let i = 0; i < this.length; i++) {
                pwd += charset[array[i] % charset.length];
            }

            this.password = pwd;

            // Strength update
            const strength = this.calculateStrength(pwd);
            this.strengthPercent = strength.percent;
            this.strengthColor = strength.color;
            this.strengthText = strength.text;

            // Add to history (prevent duplicates at top)
            if (this.history.length === 0 || this.history[0] !== pwd) {
                this.history.unshift(pwd);
                if (this.history.length > 5) this.history.pop();
            }
        }
    };
}

if (typeof window.Alpine !== 'undefined') {
    Alpine.data('passwordGenerator', passwordGenerator);
} else {
    document.addEventListener('alpine:init', () => {
        Alpine.data('passwordGenerator', passwordGenerator);
    });
}
